import { render, staticRenderFns } from "./EmployeeGender.vue?vue&type=template&id=e8acf2ac&"
import script from "./EmployeeGender.vue?vue&type=script&lang=js&"
export * from "./EmployeeGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports